import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCheckFeatureFunction } from '../../../utils/hooks';
import { Feature, QueryType } from '../../../utils/apollo/graphqlSchema';
import { getQueryTypePagePath } from '../../../utils';

const useCheckFeatureEffect = (
  feature: Feature.Prediction | Feature.Significance,
  url: string,
) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const exactUrl = pathname.startsWith(url);

  const checkFeature = useCheckFeatureFunction();

  // Redirect user to Query page in case when feature is not available
  useEffect(() => {
    if (exactUrl && !checkFeature(feature)) {
      navigate(getQueryTypePagePath(QueryType.Expression));
    }
  }, [checkFeature, exactUrl, feature, navigate]);

  return null;
};

export default useCheckFeatureEffect;
